<template>
  <div
    id="LanguangeSwitcher"
    class="row"
  >
    <div class="col-3 p-0 d-none d-sm-block" />
    <div class="col-3 p-0 text-right">
      <img
        :src="getImgUrl($i18n.locale)"
        alt="img"
        class="flag-image"
      >
    </div>
    <div class="col-5 p-0 btn-group languange-switcher">
      <button
        class="btn btn-sm dropdown-toggle button"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span
          v-if="$i18n.locale === 'en'"
          class="text pr-1"
        >English</span>
        <span
          v-if="$i18n.locale === 'id'"
          class="text pr-1"
        >Indonesia</span>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <a
          class="dropdown-item"
          @click.prevent="setLocale('en')"
        >English</a>
        <a
          class="dropdown-item"
          @click.prevent="setLocale('id')"
        >Indonesia</a>
      </div>
    </div>
    <div class="col-1" />
  </div>
</template>

<script>
export default {
  name: 'LanguangeSwitcher',
  methods: {
    setLocale (locale) {
      this.$i18n.locale = locale
      this.$router.push({
        params: { lang: locale }
      })
    },
    getImgUrl (value) {
      switch (value) {
        case 'en':
          return require('@/assets/icon/flag/en.png')
        case 'id':
          return require('@/assets/icon/flag/id.png')
      }
    }
  }
}
</script>

<style scoped>
.dropdown-menu.show{
  cursor: pointer;
}
.dropdown-item{
  font-size: 12px;
}
.languange-switcher > .button > .text{
  font-size: 12px;
  font-weight: bold;
}
.flag-image{
  width: 20px;
  padding-top: 4px;
}
</style>
